/** True for localhost and *.lvt.local. */
export function isLocalLvtHost(hostname?: string): boolean {
    const host = hostname ?? (typeof window !== "undefined" ? window.location.hostname : "");

    return host === "localhost" || host === "lvt.local" || host.endsWith(".lvt.local");
}
